import bn from 'bignumber.js';
import { resolve, noop } from './util';

export default ({ account, token, log, serviceFactory, optionContract, cache }) => cache((address) => {

  if (!address) {
    return serviceFactory({
      name: 'empty-option-service',
      subscribe: update => update({
        balance: 0
      }, false)
    })
  }
  var watchers = [];
  var subscribedAccount = null;

  return serviceFactory({
    name: 'option-service - ' + address,
    initial: {
      balance: bn(0),
      outstanding: bn(0),
      total: bn(0),
      exercise: async (amount) => {
        var contract = await optionContract.at(address);
        var decimals = await contract.decimals();
        return contract.exercise(bn(amount).times(bn(10).pow(+decimals)).toString());
      },
      withdrawAll: async () => {
        var contract = await optionContract.at(address);
        return contract.withdrawAll();
      },
      sell: async (quantity, order) => {
        var contract = await optionContract.at(address);
        //FIXME: need to get decimals from 'self...' how to make these real objects?
        return contract.sell(bn(quantity).times(bn(10).pow(18)).toString(), order);
      }
    },
    subscribe: (update) => {
      const refreshing = [true, true, true, true, true];
      const updateRefresh = (value, i) => {
        refreshing[i] = !!value._refreshing;
        update(value, refreshing.includes(true))
      }
      const tokenUnsub = token(address).subscribe(v => {
        updateRefresh(v, 0)
      })

      log.handle('option-service setup', async () => {
        const option = await optionContract.at(address);
        updateRefresh(await resolve(option, ['priceString', 'expirationString', 'expiration']), 1);
      })

      const unwatch = () => {
        watchers.forEach(w => w.stopWatching(noop));
        watchers.length = 0;
      }
      const rewatch = (fn) => {
        if (watchers.length > 0) unwatch();
        fn().forEach(w => watchers.push(w))
      }

      const acctUnsub = account.subscribe(async acct => {
        if (!acct._refreshing && acct.account !== subscribedAccount) {
          subscribedAccount = acct.account;
          const option = await optionContract.at(address);
          const decimals = await option.decimals();

          const factor = bn(10).pow(+decimals);
          const refreshValue = (name, promise, n) => promise.then(value => {
            updateRefresh({
              [name]: bn(value).div(factor)
            }, n)
          })
          const refreshOutstanding = () => log.handle("updating option-service outstanding", () => Promise.all([
            refreshValue('outstanding', option.getOutstanding(acct.account), 2),
            refreshValue('exercised', option.getExercised(acct.account), 4)
          ]));
          const refreshTotal = () => log.handle("updating option-service total", () => Promise.all([
            refreshValue('total', option.totalSupply(), 3),
            refreshValue('exercised', option.getExercised(acct.account), 4)
          ]));
          rewatch(() => [
            option.Underwrite().watch(refreshTotal),
            option.Exercise().watch(refreshTotal),
            option.Underwrite({ underwriter: acct.account }).watch(refreshOutstanding),
            option.WithdrawExercised({ underwriter: acct.account }).watch(refreshOutstanding),
            option.WithdrawUnexercised({ underwriter: acct.account }).watch(refreshOutstanding)
          ])

          await Promise.all([refreshOutstanding(), refreshTotal()])
        }
      })
      return () => {
        tokenUnsub();
        acctUnsub();
        unwatch();
        subscribedAccount = null;
      }
    }
  });
})


// WEBPACK FOOTER //
// ./src/api/option-service.js